import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllExamsStart } from "../../redux/exam/reducer";

import { getPapersStart } from "../../redux/paper/reducer";
import { paperLoading, selectPapers } from "../../redux/paper/selectors";
import usePaginationWrapper from "../general/usePaginationWrapper";
const usePapersGet = ({ id }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(paperLoading);
  const papers = useSelector(selectPapers);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);
  const [examGroupId, setExamGroupId] = useState({
    label: "Exam Group",
    value: "",
  });
  const [curriculumType, setCurriculumType] = useState({
    label: "Curriculum Type",
    value: "",
  });
  const [examId, setExamId] = useState({ label: "Exam Group", value: "" });
  const [isActive, setIsActive] = useState({
    label: "Select status",
    value: "",
  });
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const fetchPapers = useCallback(() => {
    dispatch(
      getPapersStart({
        id: id || "",
        name: debouncedSearchText,
        size: limit,
        examGroupId: examGroupId?.value,
        examId: id || examId?.value,
        page: page - 1,
        curriculum: curriculumType?.value,
        isActive:
          isActive.value === "ACTIVE"
            ? true
            : isActive.value === "INACTIVE"
            ? false
            : "",
      })
    );
  }, [
    dispatch,
    id,
    page,
    limit,
    debouncedSearchText,
    examGroupId,
    isActive,
    examId,
    curriculumType,
  ]);

  useEffect(() => {
    fetchPapers();
  }, [fetchPapers, fetch]);

  useEffect(() => {
    if (papers) {
      setPageable({
        total_elements: papers?.count,
        total_pages: papers?.pages,
        number_of_elements: papers?.items?.length,
      });
    }
  }, [papers, setPageable]);

  useEffect(() => {
    if (examGroupId.value !== undefined)
      dispatch(getAllExamsStart(examGroupId.value));
  }, [examGroupId, dispatch]);

  return {
    papers,
    loadingPapers: isLoading,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
    setExamGroupId,
    examGroupId,
    isActive,
    setIsActive,
    setExamId,
    examId,
    setCurriculumType,
    curriculumType,
  };
};

export default usePapersGet;
